// Converting between stored email-template HTML ("Hi {recipient_name}") and the
// editor's tag chips. Both directions work on the parsed DOM, not on the raw
// string: a regex over raw HTML also rewrote "{signing_link}" inside the
// link's href, which broke the link, and it left half of each chip behind on
// save.

const TAG_PATTERN = /\{([^{}]+)\}/g;
const ZERO_WIDTH_GUARD = /\uFEFF/g;

const parse = (html) => {
  const container = document.createElement('div');
  container.innerHTML = html || '';
  return container;
};

const textNodesOf = (root) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
};

/**
 * Stored HTML -> editor HTML. Only visible text becomes chips; attribute
 * values (a link's href) keep their "{tag}" untouched.
 */
export const placeholdersToChips = (html, createChip) => {
  const root = parse(html);
  textNodesOf(root).forEach((node) => {
    const text = node.nodeValue;
    TAG_PATTERN.lastIndex = 0;
    if (!TAG_PATTERN.test(text)) return;

    const fragment = document.createDocumentFragment();
    let cursor = 0;
    text.replace(TAG_PATTERN, (match, tag, offset) => {
      if (offset > cursor) fragment.appendChild(document.createTextNode(text.slice(cursor, offset)));
      fragment.appendChild(createChip(tag.trim()));
      cursor = offset + match.length;
      return match;
    });
    if (cursor < text.length) fragment.appendChild(document.createTextNode(text.slice(cursor)));
    node.parentNode.replaceChild(fragment, node);
  });
  return root.innerHTML;
};

/** Editor HTML -> stored HTML: every chip, nested spans and all, becomes "{tag}". */
export const chipsToPlaceholders = (html) => {
  const root = parse(html);
  root.querySelectorAll('.custom-tag').forEach((chip) => {
    if (!root.contains(chip)) return;
    chip.replaceWith(document.createTextNode(`{${chip.dataset.tag}}`));
  });
  return root.innerHTML.replace(ZERO_WIDTH_GUARD, '');
};
